import React from "react";

const RealHalfDoubleCrochetShape = (props) => {
  return (
    <div style={{ width: props.size, height: props.size * 1.5 }}>
      <div
        style={{
          width: props.size,
          height: props.size * 1.5,
          backgroundSize: "cover",

          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          // backgroundColor: "rgba(255, 0, 0, 0.5)",
          backgroundImage: "url('/shape_hdc.png')",
          backgroundColor: props.color,
          // border: "1px solid grey",
          boxSizing: "border-box",
        }}
      ></div>
    </div>
  );
};

export default RealHalfDoubleCrochetShape;
